import Loader from 'core/Loader';
import LoaderPage from 'pages/LoaderPage';
import React, { Suspense } from 'react';

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoaderPage />}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
